import { render, staticRenderFns } from "./category-province.vue?vue&type=template&id=742aa1fd"
import script from "./category-province.vue?vue&type=script&lang=js"
export * from "./category-province.vue?vue&type=script&lang=js"
import style0 from "./category-province.vue?vue&type=style&index=0&id=742aa1fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports